"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=stock-location.dto.js.map